import { useState, useEffect } from 'react';

interface ViewportDimensions {
    width: number;
    height: number;
}

interface ViewportState extends ViewportDimensions {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}

const useViewport = (): ViewportState => {
    const [viewport, setViewport] = useState<ViewportDimensions>({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setViewport({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        // Nettoyage de l'event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Définition des breakpoints (correspond généralement aux breakpoints Tailwind)
    const isMobile = viewport.width < 768; // md breakpoint
    const isTablet = viewport.width >= 768 && viewport.width < 1024; // lg breakpoint
    const isDesktop = viewport.width >= 1024;

    return {
        ...viewport,
        isMobile,
        isTablet,
        isDesktop,
    };
};

export default useViewport;